import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';
// import '@/sass/overrides.sass';
Vue.use(Vuetify);

export default new Vuetify({
    icons : {
        iconfont: 'mdi',
    },
    theme: {
    themes: {
      light: {
        //primary: '#94ada9',
        //primaryDark: '#30524c',
        //secondary: '#342627',
        //accent: '#F7CC25',
        //error: '#b71c1c',
        primary: '#6E8FFA',
        primaryDark: '#0D44FA',
        secondary: '#61FA76',
        accent: '#FACD55',
        error: '#b71c1c',
      },
    },
  },
});
/*
#0D44FA
#FA2D64
#6E8FFA
#FACD55
#61FA76
*/